import * as React from 'react';

export interface SelectableAccordionItemCommonProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  content?: React.ReactNode;
  disabled?: boolean;
  onClick?(e: Event, { open }: { open: boolean }): void;
}

export interface SelectableAccordionItemProps
  extends SelectableAccordionItemCommonProps {
  type?: 'radio' | 'checkbox' | 'toggle';
  open?: boolean;
  onChange?(e: Event, idx: number, open: boolean): void;
}

export default class SelectableAccordionItem extends React.Component<SelectableAccordionItemProps> {}
